import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { RESOURCES } from 'OpsCenter/app.constants';

import { Observable } from 'rxjs/Observable';
import { map } from 'rxjs/operators';

export default function merchantCategoriesService($http, RESOURCES) {
  return {
    getAllCategories,
    getCategoryById,
    getCategoryByName,
  };

  function getAllCategories() {
    return $http.get(RESOURCES.MERCHANT_CATEGORIES);
  }

  function getCategoryById(id, categories) {
    let result = null;
    if (!id || !categories || !categories.length) {
      return null;
    }

    categories.some(function(category) {
      if (category.id === id) {
        result = category;
        return true;
      }
      if (category.children.length && !result) {
        result = getCategoryById(id, category.children);
        if (result) {
          return true;
        }
      }
    });

    return result;
  }

  function getCategoryByName(name, categories) {
    let result = null;

    if (!categories || !categories.length) {
      return null;
    }

    categories.some(category => {
      if (category.name === name) {
        result = category;
        return true;
      }
      if (category.children.length && !result) {
        result = getCategoryByName(name, category.children);
        if (result) {
          return true;
        }
      }
    });

    return result;
  }
}

@Injectable()
/** @desc upgraded merchant service class to handle merchant category logic **/
export class MerchantCategoriesService {
  constructor(private http: HttpClient) {}

  /**
   * @desc Function to get a list of all merchant categories
   * @return {Observable}
   */
  getAllCategories(): Observable<any> {
    return this.http.get(RESOURCES.MERCHANT_CATEGORIES).pipe(map(res => <any>res));
  }

  /**
   * @desc Function to get specific category by id
   * @param {number} id - The id of the category to be retrieved
   * @param {array} categories - List of categories to be retrieved
   * @return {Observable}
   */
  getCategoryById(id: number, categories: Array<any>) {
    let result = null;
    if (!id || !categories || !categories.length) {
      return null;
    }

    categories.some(category => {
      if (category.id === id) {
        result = category;
        return true;
      }
      if (category.children.length && !result) {
        result = this.getCategoryById(id, category.children);
        if (result) {
          return true;
        }
      }
    });
    return result;
  }
}



// WEBPACK FOOTER //
// ./src/app/merchants/merchant-categories.service.ts